import App, {PromiseController, Tool} from "../App";
import Api from "./Api";
import Resource from "../Resource";

const fillArray = (count) => {
    const array = [];

    for (let i = 0; i < count; i++) {
        array.push([]);
    }
    return array;
};

class MDashboard {
    static hIlPromise = new PromiseController();

    static basicStatistic(props) {
        App.log('BASIC_STATISTIC', App.LOG.FETCH, props);

        const body = {
            startDate: props.startDate,
            endDate: props.endDate
        };

        return new Promise((resolve, reject) => {
            fetch(Api.MANAGEMENT_DASHBOARD.BASIC_STATISTIC, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result?.objList[0]?.enterExitDevidedByHospital_StatisticVM);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static basicStatisticDayDetail(props) {
        App.log('BASIC_STATISTIC_DAY_DETAIL', App.LOG.FETCH, props);

        const body = {
            hospitalId: props.hospitalId,
            startDate: props.startDate,
            endDate: props.endDate
        };

        return new Promise((resolve, reject) => {
            fetch(Api.MANAGEMENT_DASHBOARD.BASIC_STATISTIC_DAY_DETAIL, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result?.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static hospitalInventory(props) {
        App.log('HOSPITAL_INVENTORY', App.LOG.FETCH, props);

        const body = {
            hospitalId: props.hospitalId,
            command: 1,
            productTypeId: props.productTypeId || undefined,
            productBloodGroupId: props.productBloodGroupId || undefined
        };

        return new Promise((resolve, reject) => {
            fetch(Api.MANAGEMENT_DASHBOARD.HOSPITAL_INVENTORY, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        const list = result?.objList;

                        let productTypes = {};
                        let bloodGroups = {};

                        for (const item of list) {
                            //if productType is new one
                            if (!productTypes[item.productTypeId])
                                productTypes[item.productTypeId] = {
                                    // index: Object.keys(productTypes).length,
                                    id: item.productTypeId,
                                    shortName: item.productTypeShortNameStr,
                                    name: item.productTypeStr
                                };

                            //if bloodGroup is new one
                            if (!bloodGroups[item.bloodGroupId])
                                bloodGroups[item.bloodGroupId] = {
                                    // index: Object.keys(bloodGroups).length,
                                    id: item.bloodGroupId,
                                    shortName: item.bloodGroupShortNameStr,
                                    name: item.bloodGroupStr
                                };
                        }

                        productTypes = Object.values(productTypes);
                        bloodGroups = Object.values(bloodGroups);
                        const productTypeList = fillArray(productTypes.length);
                        const bloodGroupList = fillArray(bloodGroups.length);

                        for (let item of list) {
                            const bIndex = bloodGroups.findIndex(b => b.id === item.bloodGroupId);
                            const pIndex = productTypes.findIndex(p => p.id === item.productTypeId);

                            bloodGroupList[bIndex][pIndex] = item;
                            productTypeList[pIndex][bIndex] = item;
                        }

                        for (let b = 0; b < bloodGroups.length; b++) {
                            for (let p = 0; p < productTypes.length; p++) {
                                if (!bloodGroupList[b][p]) {
                                    bloodGroupList[b][p] = {
                                        bloodGroupId: bloodGroups[b].id,
                                        bloodGroupShortNameStr: bloodGroups[b].shortName,
                                        bloodGroupStr: bloodGroups[b].name,
                                        hospitalFullName: null,
                                        hospitalId: null,
                                        hospitalShortName: null,
                                        inventory: 0,
                                        productTypeId: productTypes[p].id,
                                        productTypeShortNameStr: productTypes[p].shortName,
                                        productTypeStr: productTypes[p].name
                                    };
                                }
                                if (!productTypeList[p][b]) {
                                    productTypeList[p][b] = {
                                        bloodGroupId: bloodGroups[b].id,
                                        bloodGroupShortNameStr: bloodGroups[b].shortName,
                                        bloodGroupStr: bloodGroups[b].name,
                                        hospitalFullName: null,
                                        hospitalId: null,
                                        hospitalShortName: null,
                                        inventory: 0,
                                        productTypeId: productTypes[p].id,
                                        productTypeShortNameStr: productTypes[p].shortName,
                                        productTypeStr: productTypes[p].name
                                    };
                                }
                            }
                        }

                        resolve({raw: list, bloodGroups, productTypes, bloodGroupList, productTypeList});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static hospitalInventoryList(props = {}) {
        App.log('HOSPITAL_INVENTORY_LIST', App.LOG.FETCH, props);

        const body = {
            ...props
            //     hospitalId: props?.hospitalId || undefined,
            //     productTypeId: props?.productTypeId || undefined,
            //     productBloodGroupId: props?.productBloodGroupId || undefined,
            //     productNumberStr: props?.productNumberStr || undefined,
            //     statusId: props?.statusId || undefined
        };

        this.hIlPromise.abort();

        return new Promise((resolve, reject) => {
            fetch(Api.MANAGEMENT_DASHBOARD.HOSPITAL_INVENTORY_LIST, {
                signal: this.hIlPromise.signal(),
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result?.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static hospitalInventoryDayDetailList(props = {}) {
        App.log('HOSPITAL_INVENTORY_DAY_DETAIL_LIST', App.LOG.FETCH, props);

        const body = {
            hospitalId: props?.hospitalId || undefined,
            command: props?.command || undefined,
            startDate: props?.startDate || undefined,
            endDate: props?.endDate || undefined
        };

        return new Promise((resolve, reject) => {
            fetch(Api.MANAGEMENT_DASHBOARD.HOSPITAL_INVENTORY_DAY_DETAIL_LIST, {
                signal: this.hIlPromise.signal(),
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result?.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }
}

export default MDashboard